import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { LocaleProvider } from 'antd';
import { resolve } from 'inversify-react';
import enUS from 'antd/lib/locale-provider/en_US'; // Set Locale EN US Global
import { connect } from "react-redux";
import { Dispatch } from "redux";

import { MainView } from './main.view';
import { CommunicationService } from 'src/core/services/communication.service';
import { ConfigurationService } from 'src/core/services/configuration.service';
import { InitializeService } from 'src/app/shared/initialize.service';
import { actionCreators } from "src/store/initialize/initialize-actions";

interface PropsFromDispatch {
	loadCurrencies: (currencies: CurrencySummary[]) => any;
	loadConfigOptions: (configOptions: ConfigOptionItem[]) => any;
}

class MainController extends React.Component<RouteComponentProps<any> & PropsFromDispatch, any> {
	@resolve
	private communicationService: CommunicationService;

	@resolve
	private configService: ConfigurationService;

	@resolve
	private initializeService: InitializeService;

	public componentDidMount(): void {
		this.loadData();
	}

	public render(): JSX.Element {
		return (
			<LocaleProvider locale={enUS}>
				<MainView {...this.props} />
			</LocaleProvider>
		);
	}

	private async loadData(): Promise<void> {
		const { loadConfigOptions, loadCurrencies } = this.props;

		await this.configService.current();
		this.communicationService.setup();
		await this.initializeService.init();
		loadConfigOptions(this.initializeService.configOptions());
		loadCurrencies(this.initializeService.currencies());
	}
}

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
	loadConfigOptions: (configOptions: ConfigOptionItem[]) => dispatch(actionCreators.loadConfigOptions(configOptions)),
	loadCurrencies: (currencies: CurrencySummary[]) => dispatch(actionCreators.loadCurrencies(currencies)),
});

const connected = connect(null, mapDispatchToProps)(MainController);
export { connected as MainController };




// WEBPACK FOOTER //
// ./src/app/main.controller.tsx